import { AssignmentStatuses, CONTEXT_LIMITS, RowTypes } from './constants';
import { getSubmissionStatus, getSubmissionStudentName, getSubmissionTotalPoints } from './entityContext';
import { pruneEmptyContext } from './contextUtils';

export const buildAssignmentVisibleRows = ({ assignments = [] }) => ({
    type: RowTypes.ASSIGNMENTS,
    items: assignments.slice(0, CONTEXT_LIMITS.VISIBLE_ROWS).map((assignment) =>
        pruneEmptyContext({
            id: assignment.id,
            title: assignment.title || assignment.name,
            status:
                assignment.active === false
                    ? AssignmentStatuses.INACTIVE
                    : assignment.is_draft
                      ? AssignmentStatuses.DRAFT
                      : AssignmentStatuses.ACTIVE,
        })
    ),
});

export const buildSubmissionVisibleRows = ({ accountUsers = [], assignment, submissions = [] }) => ({
    type: RowTypes.SUBMISSIONS,
    items: submissions.slice(0, CONTEXT_LIMITS.VISIBLE_ROWS).map((submission) =>
        pruneEmptyContext({
            id: submission.id,
            student_id: submission.user_id || submission.api?.user?.id,
            student_display_name: getSubmissionStudentName({ accountUsers, submission }),
            status: getSubmissionStatus(submission),
            grade_points: getSubmissionTotalPoints({ assignment, submission }),
            pushed_to_lms: submission.pushed_to_lms,
            updated_on: submission.modified_on || submission.created_on,
        })
    ),
});

export const buildPeopleVisibleRows = ({ accountUsers = [] }) => ({
    type: RowTypes.PEOPLE,
    items: accountUsers
        .filter(({ active, role }) => active && role === 'student')
        .slice(0, CONTEXT_LIMITS.VISIBLE_ROWS)
        .map((user) =>
            pruneEmptyContext({
                id: user.user_id || user.id || user.owner_account_id,
                display_name: user.preferredName || user.display_name || user.name,
                status: user.active ? AssignmentStatuses.ACTIVE : AssignmentStatuses.INACTIVE,
            })
        ),
});

export const buildRubricVisibleRows = ({ rubrics = [] }) => ({
    type: RowTypes.RUBRICS,
    items: rubrics.slice(0, CONTEXT_LIMITS.VISIBLE_ROWS).map((rubric) =>
        pruneEmptyContext({
            id: rubric.id,
            title: rubric.title,
            criteria_count: rubric.criteria?.length,
        })
    ),
});
